import { Navigate } from "react-router-dom";
import { getSessionItem } from "../utils/helper/session";
import { DefaultLayout } from "../pages/layouts/defaultLayout/DefaultLayout";
import { ManagerLayout } from "../pages/layouts/managerLayout/ManagerLayout";
import { AdminLayout } from "../pages/layouts/adminLayout/AdminLayout";
import { TeamLeaderLayout } from "../pages/layouts/teamLeaderLayout/TeamLeaderLayout";
import { ApplicantLayout } from "../pages/layouts/applicantLayout/ApplicantLayout";
import { RecruiterLayout } from "../pages/layouts/recruiterLayout/RecruiterLayout";

const LAYOUT_BY_ROLE = {
  CEO: AdminLayout,      // CEO
  VP: AdminLayout,      // VP
  HR: AdminLayout,      // HR
  Manager: ManagerLayout,    // Manager
  CSM: ManagerLayout,    // CSM
  "Team Leader": TeamLeaderLayout, // Team Leader
  Customer: DefaultLayout,    // Customer
  Agent: DefaultLayout,    // Agent
  Recruiter: RecruiterLayout,  // Recruiter
  Applicant: ApplicantLayout,  // Applicant
};

export function RoleLayout() {
  const user = getSessionItem("User");
  const Layout = LAYOUT_BY_ROLE[user?.roleName];

  if (!Layout) return <Navigate to="/unauthorized" replace />;
  return <Layout />;
}
